import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import PronosticoMeteorologicoService, { PronosticoMeteorologicoInterface } from '@/domain/services/PronosticoMeteorologicoService'
import { PronosticoMeteorologicoState, StoreError } from '@/store/modules/pronostico-meteorologico/types'

const pronosticoMeteorologico: PronosticoMeteorologicoInterface = new PronosticoMeteorologicoService()

export const actions: ActionTree<PronosticoMeteorologicoState, RootState> = {
  async getPronosticoMeteorologico ({ commit }): Promise<any> {
    try {
      const actionResponse = await pronosticoMeteorologico.getPronosticoMeteorologico()
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  }
}
